import List from "./components/List.vue";
import NotFound from "./components/NotFound.vue";
import About from "./components/About.vue";
import Contact from "./components/Contact.vue";
import Currency from "./components/calc/Currency.vue";
import Pension from "./components/calc/Pension.vue";
import Imei from "./components/calc/Imei.vue";
import Bus from "./components/calc/Bus.vue";
import Communal from "./components/calc/Communal.vue";
import Internet from "./components/calc/Internet.vue";
import Post from "./components/calc/Post.vue";
import Prayer from "./components/calc/Prayer.vue";
import Medicine from "./components/calc/Medicine.vue";
import Weather from "./components/calc/Weather.vue";
import Road from "./components/calc/Road.vue";
import Translate from "./components/calc/Translate.vue";
import Realestate from "./components/calc/Realestate.vue";
import Visa from "./components/calc/Visa.vue";
import Salary from "./components/calc/Salary.vue";
import Inspection from "./components/calc/Inspection.vue";
import Calories from "./components/calc/Calories.vue";
import Bodymass from "./components/calc/Bodymass.vue";
import Customs from "./components/calc/Customs.vue";

export const routes = [
  { path: "/", component: List, meta: { title: "Məlumat Portalı" } },
  {
    path: "/404",
    component: NotFound,
    meta: { title: "Səhifə Tapılmadı - Məlumat Portalı" }
  },
  { path: "*", redirect: "/404" },
  {
    path: "/about",
    component: About,
    meta: { title: "Haqqımızda - Məlumat Portalı" }
  },
  {
    path: "/contact",
    component: Contact,
    meta: { title: "Bizimlə əlaqə - Məlumat Portalı" }
  },
  {
    path: "/currency",
    component: Currency,
    meta: { title: "Valyuta Konvertoru - Məlumat Portalı" }
  },
  {
    path: "/pension",
    component: Pension,
    meta: { title: "Pensiya Kalkulyatoru - Məlumat Portalı" }
  },
  {
    path: "/imei",
    component: Imei,
    meta: { title: "Mobil Telefonların Qeydiyyat Rüsumu - Məlumat Portalı" }
  },
  {
    path: "/calories",
    component: Calories,
    meta: { title: "Qidaların Kalori Cədvəli - Məlumat Portalı" }
  },
  {
    path: "/bodymass",
    component: Bodymass,
    meta: { title: "İdeal Çəki Kalkulyatoru - Məlumat Portalı" }
  },
  {
    path: "/bus",
    component: Bus,
    meta: {
      title:
        "Beynəlxalq və Ölkədaxili Sərnişindaşıma qiymətləri - Məlumat Portalı"
    }
  },
  {
    path: "/communal",
    component: Communal,
    meta: { title: "Kommunal Xidmətlər - Məlumat Portalı" }
  },
  {
    path: "/internet",
    component: Internet,
    meta: { title: "İP ünvan və İnternet Provayderlər - Məlumat Portalı" }
  },
  {
    path: "/post",
    component: Post,
    meta: { title: "Poçt Rabitəsi Xidmətləri - Məlumat Portalı" }
  },
  {
    path: "/translate",
    component: Translate,
    meta: { title: "Onlayn Tərcümə Servisi - Məlumat Portalı" }
  },
  {
    path: "/prayer",
    component: Prayer,
    meta: { title: "Namaz Vaxtları Azərbaycan - Məlumat Portalı" }
  },
  {
    path: "/medicine",
    component: Medicine,
    meta: { title: "Dərmanların Qiymətləri - Məlumat Portalı" }
  },
  {
    path: "/weather",
    component: Weather,
    meta: { title: "Hava Proqnozu Azərbaycan - Məlumat Portalı" }
  },
  {
    path: "/road",
    component: Road,
    meta: { title: "Məsafə və Yanacaq Sərfi - Məlumat Portalı" }
  },
  {
    path: "/realestate",
    component: Realestate,
    meta: {
      title: "Daşınmaz Əmlak Satışından Verginin Hesablanması - Məlumat Portalı"
    }
  },
  {
    path: "/visa",
    component: Visa,
    meta: {
      title: "Azərbaycan Vətəndaşları üçün Viza Tələbləri - Məlumat Portalı"
    }
  },
  {
    path: "/salary",
    component: Salary,
    meta: {
      title: "Əmək Haqqından Tutulmaların Hesablanması - Məlumat Portalı"
    }
  },
  {
    path: "/inspection",
    component: Inspection,
    meta: { title: "Avtomobillərin Texniki Baxışı - Məlumat Portalı" }
  },
  {
    path: "/customs",
    component: Customs,
    meta: {
      title: "Gömrük kalkulyatoru Nəqliyyat vaistələri - Məlumat Portalı"
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes.js